// extracted by mini-css-extract-plugin
module.exports = {"bookAppointmentContainer":"book-appointments_bookAppointmentContainer__PfoFy"};